<template>
  <o-form-wrapper
    v-model="item"
    :server-errors="_se"
    :v="$v.item"
    :schema="schema"
    :form-state="formState"
  >
    <div>
      <b-card no-body>
        <b-tabs card>
          <b-tab title="Original" active>
            <o-widget-wrapper
              v-if="!create"
              :schema="schema"
              name="id"
              :validators="$v.item"
              :server-errors="_se"
              :form-state="formState"
            >
              <o-text-field
                v-model="item.id"
                :form-state="formState"
                name="id"
                :validators="$v.item"
                :server-errors="_se"
                v-bind="schema.fields.id"
              ></o-text-field>
            </o-widget-wrapper>

            <o-widget-wrapper
              v-if="!create && item.original_job_number"
              :schema="schema"
              name="original_job_number"
              :validators="$v.item"
              :server-errors="_se"
              :form-state="formState"
            >
              <o-text-field
                v-model="item.original_job_number"
                :form-state="formState"
                name="original_job_number"
                :validators="$v.item"
                :server-errors="_se"
                v-bind="schema.fields.original_job_number"
                readonly
              ></o-text-field>
            </o-widget-wrapper>

            <o-widget-wrapper
              :schema="schema"
              name="job_type"
              :validators="$v.item"
              :server-errors="_se"
              :form-state="formState"
            >
              <o-select
                v-model="item.job_type"
                :items="optionCodeJobTypeItems"
                text-field="description"
                value-field="id"
                sort-field="description"
                :form-state="formState"
                :loading="optionCodeJobTypeWorking"
                name="job_type"
                :validators="$v.item"
                :server-errors="_se"
                @input="select_job_type"
                v-bind="schema.fields.job_type"
                store-name="CodeJobType"
              >
              </o-select>
            </o-widget-wrapper>

            <o-widget-wrapper
              :schema="schema"
              name="site_cut"
              :validators="$v.item"
              :server-errors="_se"
              :form-state="formState"
              v-if="item.site_cut"
            >
              <o-checkbox
                v-model="item.site_cut"
                :form-state="formState"
                name="site_cut"
                :validators="$v.item"
                :server-errors="_se"
                v-bind="schema.fields.site_cut"
              ></o-checkbox>
            </o-widget-wrapper>

            <o-widget-wrapper
              :schema="schema"
              name="site_cut_retaining_walls"
              :validators="$v.item"
              :server-errors="_se"
              :form-state="formState"
              v-if="item.site_cut_retaining_walls"
            >
              <o-checkbox
                v-model="item.site_cut_retaining_walls"
                :form-state="formState"
                name="site_cut_retaining_walls"
                :validators="$v.item"
                :server-errors="_se"
                v-bind="schema.fields.site_cut_retaining_walls"
              ></o-checkbox>
            </o-widget-wrapper>

            <o-widget-wrapper
              :schema="schema"
              name="customer"
              :validators="$v.item"
              :server-errors="_se"
              :form-state="formState"
            >
              <o-select
                v-model="item.customer"
                :items="optionCustomerItems"
                text-field="name"
                value-field="id"
                sort-field="name"
                :form-state="formState"
                @input="selected_customer"
                :loading="optionCustomerWorking"
                name="customer"
                :validators="$v.item"
                :server-errors="_se"
                v-bind="schema.fields.customer"
                store-name="Customer"
              >
              </o-select>
            </o-widget-wrapper>

            <o-widget-wrapper
              :schema="schema"
              name="site_address"
              :validators="$v.item"
              :server-errors="_se"
              :form-state="formState"
            >
              <o-text-field
                v-model="item.site_address"
                :form-state="formState"
                name="site_address"
                :validators="$v.item"
                :server-errors="_se"
                v-bind="schema.fields.site_address"
              ></o-text-field>
            </o-widget-wrapper>

            <o-widget-wrapper
              :schema="schema"
              name="suburb"
              :validators="$v.item"
              :server-errors="_se"
              :form-state="formState"
            >
              <o-text-field
                v-model="item.suburb"
                :form-state="formState"
                name="suburb"
                :validators="$v.item"
                :server-errors="_se"
                v-bind="schema.fields.suburb"
              ></o-text-field>
            </o-widget-wrapper>

            <o-widget-wrapper
              :schema="schema"
              name="job_location"
              :validators="$v.item"
              :server-errors="_se"
              :form-state="formState"
            >
              <o-select
                v-model="item.job_location"
                :items="optionCodeJobLocationItems"
                text-field="description"
                value-field="id"
                sort-field="description"
                :form-state="formState"
                :loading="optionCodeJobLocationWorking"
                name="job_location"
                :validators="$v.item"
                :server-errors="_se"
                v-bind="schema.fields.job_location"
                store-name="CodeJobLocation"
              >
              </o-select>
            </o-widget-wrapper>

            <o-widget-wrapper
              v-if="showOtherFields"
              :schema="schema"
              name="m2"
              :validators="$v.item"
              :server-errors="_se"
              :form-state="formState"
            >
              <o-number-field
                v-model="item.m2"
                :form-state="formState"
                name="m2"
                align-left
                :validators="$v.item"
                :server-errors="_se"
                v-bind="schema.fields.m2"
              ></o-number-field>
            </o-widget-wrapper>
            <o-widget-wrapper
              :form-state="formState"
              :schema="schema"
              :server-errors="_se"
              :validators="$v.item"
              name="complexity"
            >
              <b-form-group
                label="Complexity"
                label-cols="3"
                label-cols-lg="2"
                label-align="right"
              >
                <o-speed-select
                  :form-state="formState"
                  :items="optionCodeComplexityItems"
                  :validators="{}"
                  color-field="color"
                  name="complexity"
                  text-field="description"
                  v-bind="schema.fields.complexity"
                  v-model="item.complexity"
                  value="id"
                  quick-display-order-field="display_order"
                ></o-speed-select>
              </b-form-group>
            </o-widget-wrapper>

            <o-widget-wrapper
              :schema="schema"
              name="supervisor"
              :validators="$v.item"
              :server-errors="_se"
              :form-state="formState"
            >
              <o-select
                v-model="item.supervisor"
                :items="optionSupervisorItems"
                text-field="name"
                value-field="id"
                sort-field="name"
                :form-state="formState"
                :loading="optionSupervisorWorking"
                name="supervisor"
                :validators="$v.item"
                :server-errors="_se"
                v-bind="schema.fields.supervisor"
                store-name="Supervisor"
                @input="setSupervisorMobile()"
              >
              </o-select>
            </o-widget-wrapper>

            <o-widget-wrapper
              :schema="schema"
              name="mobile_phone_no"
              :validators="$v.item"
              :server-errors="_se"
              :form-state="formState"
            >
              <o-text-field
                v-model="item.mobile_phone_no"
                :form-state="formState"
                name="mobile_phone_no"
                :validators="$v.item"
                :server-errors="_se"
                v-bind="schema.fields.mobile_phone_no"
              ></o-text-field>
            </o-widget-wrapper>

            <o-widget-wrapper
              :schema="schema"
              name="active_start_date"
              :validators="$v.item"
              :server-errors="_se"
              :form-state="formState"
            >
              <o-date-time
                v-model="item.active_start_date"
                name="active_start_date"
                v-bind="schema.fields.active_start_date"
                :form-state="formState"
                :validators="$v.item"
                :server-errors="_se"
              ></o-date-time>
            </o-widget-wrapper>

            <o-widget-wrapper
              :schema="schema"
              name="active_end_date"
              :validators="$v.item"
              :server-errors="_se"
              :form-state="formState"
            >
              <o-date-time
                v-model="item.active_end_date"
                name="active_end_date"
                v-bind="schema.fields.active_end_date"
                :form-state="formState"
                :validators="$v.item"
                :server-errors="_se"
              ></o-date-time>
            </o-widget-wrapper>

            <br />
            <div v-if="showOtherFields">
              <h3>Dates</h3>

              <o-widget-wrapper
                :schema="schema"
                name="date_call_up_received"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-date-time
                  v-model="item.date_call_up_received"
                  name="date_call_up_received"
                  v-bind="schema.fields.date_call_up_received"
                  :form-state="formState"
                  :validators="$v.item"
                  :server-errors="_se"
                ></o-date-time>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="set_out_date"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-date-time
                  v-model="item.set_out_date"
                  name="set_out_date"
                  v-bind="schema.fields.set_out_date"
                  :form-state="formState"
                  :validators="$v.item"
                  :server-errors="_se"
                ></o-date-time>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="drain_date"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-date-time
                  v-model="item.drain_date"
                  name="drain_date"
                  v-bind="schema.fields.drain_date"
                  :form-state="formState"
                  :validators="$v.item"
                  :server-errors="_se"
                ></o-date-time>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="wanted_pour_date"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-date-time
                  v-model="item.wanted_pour_date"
                  name="wanted_pour_date"
                  v-bind="schema.fields.wanted_pour_date"
                  :form-state="formState"
                  :validators="$v.item"
                  :server-errors="_se"
                ></o-date-time>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="pour_date"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-date-time
                  v-model="item.pour_date"
                  name="pour_date"
                  v-bind="schema.fields.pour_date"
                  :form-state="formState"
                  :validators="$v.item"
                  :server-errors="_se"
                ></o-date-time>
              </o-widget-wrapper>
            </div>
            <div v-if="showSiteCut" class="for-site-cut">
              <br />
              <h3>Site Cut</h3>

              <o-widget-wrapper
                :schema="schema"
                name="site_cut_date_received"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-date-time
                  v-model="item.site_cut_date_received"
                  name="site_cut_date_received"
                  v-bind="schema.fields.site_cut_date_received"
                  :form-state="formState"
                  :validators="$v.item"
                  :server-errors="_se"
                  hide-time
                ></o-date-time>
              </o-widget-wrapper>
              <o-widget-wrapper
                :schema="schema"
                name="site_cut_date"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-date-time
                  v-model="item.site_cut_date"
                  name="site_cut_date"
                  v-bind="schema.fields.site_cut_date"
                  :form-state="formState"
                  :validators="$v.item"
                  :server-errors="_se"
                  hide-time
                ></o-date-time>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="site_cut_crew"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-select
                  v-model="item.site_cut_crew"
                  :items="sitecutSupplierType"
                  text-field="name"
                  value-field="id"
                  sort-field="name"
                  :form-state="formState"
                  :loading="optionSupplierWorking"
                  name="site_cut_crew"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.site_cut_crew"
                  allow-add
                  store-name="Supplier"
                  add-title="Create New"
                >
                  <template
                    slot="form"
                    slot-scope="{ item, formState, serverErrors }"
                  >
                    <supplier-form
                      :item="item"
                      :form-state="formState"
                      :server-errors="serverErrors"
                      in-modal
                    ></supplier-form>
                  </template>
                </o-select>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="site_cut_operator_2"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-select
                  v-model="item.site_cut_operator_2"
                  :items="sitecutSupplierType"
                  text-field="name"
                  value-field="id"
                  sort-field="name"
                  :form-state="formState"
                  :loading="optionSupplierWorking"
                  name="site_cut_operator_2"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.site_cut_operator_2"
                  allow-add
                  store-name="Supplier"
                  add-title="Create New"
                >
                  <template
                    slot="form"
                    slot-scope="{ item, formState, serverErrors }"
                  >
                    <supplier-form
                      :item="item"
                      :form-state="formState"
                      :server-errors="serverErrors"
                      in-modal
                    ></supplier-form>
                  </template>
                </o-select>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="site_cut_ohs"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-checkbox
                  v-model="item.site_cut_ohs"
                  :form-state="formState"
                  name="site_cut_ohs"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.site_cut_ohs"
                ></o-checkbox>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="site_cut_wanted_date"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-date-time
                  v-model="item.site_cut_wanted_date"
                  name="site_cut_wanted_date"
                  v-bind="schema.fields.site_cut_wanted_date"
                  :form-state="formState"
                  :validators="$v.item"
                  :server-errors="_se"
                  hide-time
                ></o-date-time>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="site_cut_spoil"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-select
                  v-model="item.site_cut_spoil"
                  :items="spoilSupplierType"
                  text-field="name"
                  value-field="id"
                  sort-field="name"
                  :form-state="formState"
                  :loading="optionSupplierWorking"
                  name="site_cut_spoil"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.site_cut_spoil"
                  allow-add
                  store-name="Supplier"
                  add-title="Create New"
                >
                  <template
                    slot="form"
                    slot-scope="{ item, formState, serverErrors }"
                  >
                    <supplier-form
                      :item="item"
                      :form-state="formState"
                      :server-errors="serverErrors"
                      in-modal
                    ></supplier-form>
                  </template>
                </o-select>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="spoil_removal_2"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-select
                  v-model="item.spoil_removal_2"
                  :items="spoilSupplierType"
                  text-field="name"
                  value-field="id"
                  sort-field="name"
                  :form-state="formState"
                  :loading="optionSupplierWorking"
                  name="spoil_removal_2"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.spoil_removal_2"
                  allow-add
                  store-name="Supplier"
                  add-title="Create New"
                >
                  <template
                    slot="form"
                    slot-scope="{ item, formState, serverErrors }"
                  >
                    <supplier-form
                      :item="item"
                      :form-state="formState"
                      :server-errors="serverErrors"
                      in-modal
                    ></supplier-form>
                  </template>
                </o-select>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="site_cut_tipsite"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-select
                  v-model="item.site_cut_tipsite"
                  :items="siteCutTipSiteSupplierType"
                  text-field="name"
                  value-field="id"
                  sort-field="name"
                  :form-state="formState"
                  :loading="optionSupplierWorking"
                  name="site_cut_tipsite"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.site_cut_tipsite"
                  allow-add
                  store-name="Supplier"
                  add-title="Create New"
                >
                  <template
                    slot="form"
                    slot-scope="{ item, formState, serverErrors }"
                  >
                    <supplier-form
                      :item="item"
                      :form-state="formState"
                      :server-errors="serverErrors"
                      in-modal
                    ></supplier-form>
                  </template>
                </o-select>
              </o-widget-wrapper>
              <o-widget-wrapper
                :schema="schema"
                name="site_cut_percentage_done"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-number-field
                  v-model="item.site_cut_percentage_done"
                  :form-state="formState"
                  name="site_cut_percentage_done"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.site_cut_percentage_done"
                  align-left
                ></o-number-field>
              </o-widget-wrapper>
            </div>
            <div v-if="showRetainingWalls" class="for-retaining-walls">
              <br />
              <h3>Retaining Walls</h3>

              <o-widget-wrapper
                :schema="schema"
                name="retaining_walls_received_date"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-date-time
                  v-model="item.retaining_walls_received_date"
                  name="retaining_walls_received_date"
                  v-bind="schema.fields.retaining_walls_received_date"
                  :form-state="formState"
                  :validators="$v.item"
                  :server-errors="_se"
                  hide-time
                ></o-date-time>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="retaining_walls_wanted_date"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-date-time
                  v-model="item.retaining_walls_wanted_date"
                  name="retaining_walls_wanted_date"
                  v-bind="schema.fields.retaining_walls_wanted_date"
                  :form-state="formState"
                  :validators="$v.item"
                  :server-errors="_se"
                  hide-time
                ></o-date-time>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="retaining_walls_actual_date"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-date-time
                  v-model="item.retaining_walls_actual_date"
                  name="retaining_walls_actual_date"
                  v-bind="schema.fields.retaining_walls_actual_date"
                  :form-state="formState"
                  :validators="$v.item"
                  :server-errors="_se"
                  hide-time
                ></o-date-time>
              </o-widget-wrapper>
            </div>

            <div v-if="showOtherFields">
              <h3>Pier</h3>

              <o-widget-wrapper
                :schema="schema"
                name="pier_date"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-date-time
                  v-model="item.pier_date"
                  name="pier_date"
                  v-bind="schema.fields.pier_date"
                  :form-state="formState"
                  :validators="$v.item"
                  :server-errors="_se"
                ></o-date-time>
              </o-widget-wrapper>
              <o-widget-wrapper
                :schema="schema"
                name="actual_pier_date"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-date-time
                  v-model="item.actual_pier_date"
                  name="actual_pier_date"
                  v-bind="schema.fields.actual_pier_date"
                  :form-state="formState"
                  :validators="$v.item"
                  :server-errors="_se"
                ></o-date-time>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="no_of_piers"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-number-field
                  v-model="item.no_of_piers"
                  :form-state="formState"
                  name="no_of_piers"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.no_of_piers"
                  align-left
                ></o-number-field>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="piers_crew"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-select
                  v-model="item.piers_crew"
                  :items="piersSupplierType"
                  text-field="name"
                  value-field="id"
                  sort-field="name"
                  :form-state="formState"
                  :loading="optionSupplierWorking"
                  name="piers_crew"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.piers_crew"
                  store-name="Supplier"
                >
                </o-select>
              </o-widget-wrapper>
              <o-widget-wrapper
                :schema="schema"
                name="pier_pump_supplier"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-select
                  v-model="item.pier_pump_supplier"
                  :items="pumpSupplierType"
                  text-field="name"
                  value-field="id"
                  sort-field="name"
                  :form-state="formState"
                  :loading="optionSupplierWorking"
                  name="pier_pump_supplier"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.pier_pump_supplier"
                  store-name="Supplier"
                >
                  <template
                    slot="form"
                    slot-scope="{ item, formState, serverErrors }"
                  >
                    <supplier-form
                      :item="item"
                      :form-state="formState"
                      :server-errors="serverErrors"
                      in-modal
                    ></supplier-form>
                  </template>
                </o-select>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="pier_inspection_date"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-date-time
                  v-model="item.pier_inspection_date"
                  name="pier_inspection_date"
                  v-bind="schema.fields.pier_inspection_date"
                  :form-state="formState"
                  :validators="$v.item"
                  :server-errors="_se"
                ></o-date-time>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="pier_inspector_supplier"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-select
                  v-model="item.pier_inspector_supplier"
                  :items="steelSupplierType"
                  text-field="name"
                  value-field="id"
                  sort-field="name"
                  :form-state="formState"
                  :loading="optionSupplierWorking"
                  name="pier_inspector_supplier"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.pier_inspector_supplier"
                  store-name="Supplier"
                >
                  <!-- <template
                    slot="form"
                    slot-scope="{ item, formState, serverErrors }"
                  >
                    <supplier-form
                      :item="item"
                      :form-state="formState"
                      :server-errors="serverErrors"
                      in-modal
                    ></supplier-form>
                  </template> -->
                </o-select>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="pier_booking_no"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-text-field
                  v-model="item.pier_booking_no"
                  :form-state="formState"
                  name="pier_booking_no"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.pier_booking_no"
                ></o-text-field>
              </o-widget-wrapper>
              <o-widget-wrapper
                :schema="schema"
                name="drilled"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-checkbox
                  v-model="item.drilled"
                  :form-state="formState"
                  name="drilled"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.drilled"
                ></o-checkbox>
              </o-widget-wrapper>
              <o-widget-wrapper
                :schema="schema"
                name="is_pier_passed"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-checkbox
                  v-model="item.is_pier_passed"
                  :form-state="formState"
                  name="is_pier_passed"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.is_pier_passed"
                ></o-checkbox>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="pier_ohs"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-checkbox
                  v-model="item.pier_ohs"
                  :form-state="formState"
                  name="pier_ohs"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.pier_ohs"
                ></o-checkbox>
              </o-widget-wrapper>
              <o-widget-wrapper
                :schema="schema"
                name="revisit_required"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-checkbox
                  v-model="item.revisit_required"
                  :form-state="formState"
                  name="revisit_required"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.revisit_required"
                ></o-checkbox>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="piers_excavator"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-select
                  v-model="item.piers_excavator"
                  :items="piersSupplierType"
                  text-field="name"
                  value-field="id"
                  sort-field="name"
                  :form-state="formState"
                  :loading="optionSupplierWorking"
                  name="piers_excavator"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.piers_excavator"
                  store-name="Supplier"
                >
                </o-select>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="revisit_comment"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-text-field
                  v-model="item.revisit_comment"
                  :form-state="formState"
                  name="revisit_comment"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.revisit_comment"
                ></o-text-field>
              </o-widget-wrapper>
              <o-widget-wrapper
                :schema="schema"
                name="piers_concrete_ordered"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-number-field
                  v-model="item.piers_concrete_ordered"
                  :form-state="formState"
                  name="piers_concrete_ordered"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.piers_concrete_ordered"
                  align-left
                ></o-number-field>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="pier_concrete_notes"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-textarea
                  :form-state="formState"
                  :server-errors="_se"
                  :validators="$v.item"
                  name="pier_concrete_notes"
                  v-bind="schema.fields.pier_concrete_notes"
                  v-model="item.pier_concrete_notes"
                ></o-textarea>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="base_inspector_supplier"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-select
                  v-model="item.base_inspector_supplier"
                  :items="steelSupplierType"
                  text-field="name"
                  value-field="id"
                  sort-field="name"
                  :form-state="formState"
                  :loading="optionSupplierWorking"
                  name="base_inspector_supplier"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.base_inspector_supplier"
                  allow-add
                  store-name="Supplier"
                  add-title="Create New"
                >
                  <template
                    slot="form"
                    slot-scope="{ item, formState, serverErrors }"
                  >
                    <supplier-form
                      :item="item"
                      :form-state="formState"
                      :server-errors="serverErrors"
                      in-modal
                    ></supplier-form>
                  </template>
                </o-select>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="pier_concrete_supplier"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-select
                  v-model="item.pier_concrete_supplier"
                  :items="concreteSupplierType"
                  text-field="name"
                  value-field="id"
                  sort-field="name"
                  :form-state="formState"
                  :loading="optionSupplierWorking"
                  name="pier_concrete_supplier"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.pier_concrete_supplier"
                  store-name="Supplier"
                >
                </o-select>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="pier_poured_by_supplier"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-select
                  v-model="item.pier_poured_by_supplier"
                  :items="crewSupplierType"
                  text-field="name"
                  value-field="id"
                  sort-field="name"
                  :form-state="formState"
                  :loading="optionSupplierWorking"
                  name="pier_poured_by_supplier"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.pier_poured_by_supplier"
                  allow-add
                  store-name="Supplier"
                  add-title="Create New"
                >
                  <template
                    slot="form"
                    slot-scope="{ item, formState, serverErrors }"
                  >
                    <supplier-form
                      :item="item"
                      :form-state="formState"
                      :server-errors="serverErrors"
                      in-modal
                    ></supplier-form>
                  </template>
                </o-select>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="pier_inspection_approved"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-checkbox
                  v-model="item.pier_inspection_approved"
                  :form-state="formState"
                  name="pier_inspection_approved"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.pier_inspection_approved"
                ></o-checkbox>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="pier_concrete_confirmed"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-checkbox
                  v-model="item.pier_concrete_confirmed"
                  :form-state="formState"
                  name="pier_concrete_confirmed"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.pier_concrete_confirmed"
                ></o-checkbox>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="pier_concrete_time"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-date-time
                  v-model="item.pier_concrete_time"
                  name="pier_concrete_time"
                  v-bind="schema.fields.pier_concrete_time"
                  :form-state="formState"
                  :validators="$v.item"
                  :server-errors="_se"
                ></o-date-time>
              </o-widget-wrapper>
            </div>

            <div v-if="showOtherFields">
              <h3>Termite</h3>

              <o-widget-wrapper
                :schema="schema"
                name="part_a_required"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-checkbox
                  v-model="item.part_a_required"
                  :form-state="formState"
                  name="part_a_required"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.part_a_required"
                ></o-checkbox>
              </o-widget-wrapper>

              <o-widget-wrapper
                v-if="item.part_a_required"
                :schema="schema"
                name="termite_part_a_date"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-date-time
                  v-model="item.termite_part_a_date"
                  name="termite_part_a_date"
                  v-bind="schema.fields.termite_part_a_date"
                  :form-state="formState"
                  :validators="$v.item"
                  :server-errors="_se"
                ></o-date-time>
              </o-widget-wrapper>

              <o-widget-wrapper
                v-if="item.part_a_required"
                :schema="schema"
                name="part_a_supplier"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-select
                  v-model="item.part_a_supplier"
                  :items="partASupplierType"
                  text-field="name"
                  value-field="id"
                  sort-field="name"
                  :form-state="formState"
                  :loading="optionSupplierWorking"
                  name="part_a_supplier"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.part_a_supplier"
                  allow-add
                  store-name="Supplier"
                  add-title="Create New"
                >
                  <template
                    slot="form"
                    slot-scope="{ item, formState, serverErrors }"
                  >
                    <supplier-form
                      :item="item"
                      :form-state="formState"
                      :server-errors="serverErrors"
                      in-modal
                    ></supplier-form>
                  </template>
                </o-select>
              </o-widget-wrapper>
              <o-widget-wrapper
                v-if="item.part_a_required"
                :schema="schema"
                name="termite_part_a_booked"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-checkbox
                  v-model="item.termite_part_a_booked"
                  :form-state="formState"
                  name="termite_part_a_booked"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.termite_part_a_booked"
                ></o-checkbox>
              </o-widget-wrapper>
              <o-widget-wrapper
                v-if="item.part_a_required"
                :schema="schema"
                name="termite_part_a_booking_no"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-text-field
                  v-model="item.termite_part_a_booking_no"
                  :form-state="formState"
                  name="termite_part_a_booking_no"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.termite_part_a_booking_no"
                ></o-text-field>
              </o-widget-wrapper>
            </div>

            <div v-if="showOtherFields">
              <h3>Excavation</h3>

              <o-widget-wrapper
                :schema="schema"
                name="bob_cat_date"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-date-time
                  v-model="item.bob_cat_date"
                  name="bob_cat_date"
                  v-bind="schema.fields.bob_cat_date"
                  :form-state="formState"
                  :validators="$v.item"
                  :server-errors="_se"
                ></o-date-time>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="bob_cat"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-select
                  v-model="item.bob_cat"
                  :items="bobcatSupplierType"
                  text-field="name"
                  value-field="id"
                  sort-field="name"
                  :form-state="formState"
                  :loading="optionSupplierWorking"
                  name="bob_cat"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.bob_cat"
                  store-name="Supplier"
                >
                </o-select>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="bob_cat_2"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-select
                  v-model="item.bob_cat_2"
                  :items="bobcatSupplierType"
                  text-field="name"
                  value-field="id"
                  sort-field="name"
                  :form-state="formState"
                  :loading="optionSupplierWorking"
                  name="bob_cat_2"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.bob_cat_2"
                  allow-add
                  store-name="Supplier"
                  add-title="Create New"
                >
                  <template
                    slot="form"
                    slot-scope="{ item, formState, serverErrors }"
                  >
                    <supplier-form
                      :item="item"
                      :form-state="formState"
                      :server-errors="serverErrors"
                      in-modal
                    ></supplier-form>
                  </template>
                </o-select>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="bob_cat_ohs"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-checkbox
                  v-model="item.bob_cat_ohs"
                  :form-state="formState"
                  name="bob_cat_ohs"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.bob_cat_ohs"
                ></o-checkbox>
              </o-widget-wrapper>
            </div>

            <div v-if="showOtherFields">
              <h3>Pre Slab</h3>

              <o-widget-wrapper
                :schema="schema"
                name="pre_slab_booked_date"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-date-time
                  v-model="item.pre_slab_booked_date"
                  name="pre_slab_booked_date"
                  v-bind="schema.fields.pre_slab_booked_date"
                  :form-state="formState"
                  :validators="$v.item"
                  :server-errors="_se"
                ></o-date-time>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="pre_slab_booking_no"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-text-field
                  v-model="item.pre_slab_booking_no"
                  :form-state="formState"
                  name="pre_slab_booking_no"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.pre_slab_booking_no"
                ></o-text-field>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="pre_slab_inspection_passed"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-checkbox
                  v-model="item.pre_slab_inspection_passed"
                  :form-state="formState"
                  name="pre_slab_inspection_passed"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.pre_slab_inspection_passed"
                ></o-checkbox>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="pre_slab_passed"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-date-time
                  v-model="item.pre_slab_passed"
                  :form-state="formState"
                  :server-errors="_se"
                  :validators="$v.item"
                  name="pre_slab_passed"
                  v-bind="schema.fields.pre_slab_passed"
                ></o-date-time>
              </o-widget-wrapper>

              <o-widget-wrapper
                :form-state="formState"
                :schema="schema"
                :server-errors="_se"
                :validators="$v.item"
                name="pre_slab_notes"
              >
                <o-textarea
                  :form-state="formState"
                  :server-errors="_se"
                  :validators="$v.item"
                  name="pre_slab_notes"
                  v-bind="schema.fields.pre_slab_notes"
                  v-model="item.pre_slab_notes"
                ></o-textarea>
              </o-widget-wrapper>
            </div>
            <br />
            <div v-if="showOtherFields">
              <h3>Contractors</h3>

              <o-widget-wrapper
                :schema="schema"
                name="crew_supplier"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-select
                  v-model="item.crew_supplier"
                  :items="optionCrewSupplierItems"
                  text-field="name"
                  value-field="id"
                  sort-field="name"
                  :form-state="formState"
                  :loading="optionSupplierWorking"
                  name="crew_supplier"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.crew_supplier"
                  allow-add
                  store-name="Supplier"
                  add-title="Create New"
                >
                  <template
                    slot="form"
                    slot-scope="{ item, formState, serverErrors }"
                  >
                    <supplier-form
                      :item="item"
                      :form-state="formState"
                      :server-errors="serverErrors"
                      in-modal
                    ></supplier-form>
                  </template>
                </o-select>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="plan_provided"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-checkbox
                  v-model="item.plan_provided"
                  :form-state="formState"
                  name="plan_provided"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.plan_provided"
                ></o-checkbox>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="rock_date"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-date-time
                  v-model="item.rock_date"
                  name="rock_date"
                  v-bind="schema.fields.rock_date"
                  :form-state="formState"
                  :validators="$v.item"
                  :server-errors="_se"
                ></o-date-time>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="rock_m2"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-number-field
                  v-model="item.rock_m2"
                  :form-state="formState"
                  name="rock_m2"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.rock_m2"
                  align-left
                ></o-number-field>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="steel_ordered"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-checkbox
                  v-model="item.steel_ordered"
                  :form-state="formState"
                  name="steel_ordered"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.steel_ordered"
                ></o-checkbox>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="inspector"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-select
                  v-model="item.inspector"
                  :items="inspectors_list"
                  text-field="name"
                  value-field="id"
                  sort-field="name"
                  :form-state="formState"
                  :loading="optionSupplierWorking"
                  name="inspector"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.inspector"
                  store-name="Supplier"
                >
                </o-select>
              </o-widget-wrapper>

              <o-checkbox
                name="show_all_inspectors_checkbox"
                v-model="show_all_inspectors_checkbox"
                label="Show All Inspectors"
                :form-state="formState"
                :validators="$v.item"
                :server-errors="_se"
              ></o-checkbox>

              <o-widget-wrapper
                :schema="schema"
                name="steel_inspection_date"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-date-time
                  v-model="item.steel_inspection_date"
                  name="steel_inspection_date"
                  v-bind="schema.fields.steel_inspection_date"
                  :form-state="formState"
                  :validators="$v.item"
                  :server-errors="_se"
                ></o-date-time>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="steel_inspection_passed"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-checkbox
                  v-model="item.steel_inspection_passed"
                  :form-state="formState"
                  name="steel_inspection_passed"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.steel_inspection_passed"
                ></o-checkbox>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="steel_booking_number"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-text-field
                  :form-state="formState"
                  :server-errors="_se"
                  :validators="$v.item"
                  name="steel_booking_number"
                  v-bind="schema.fields.steel_booking_number"
                  v-model="item.steel_booking_number"
                ></o-text-field>
              </o-widget-wrapper>

              <o-widget-wrapper
                :form-state="formState"
                :schema="schema"
                :server-errors="_se"
                :validators="$v.item"
                name="steel_notes"
              >
                <o-textarea
                  :form-state="formState"
                  :server-errors="_se"
                  :validators="$v.item"
                  name="steel_notes"
                  v-bind="schema.fields.steel_notes"
                  v-model="item.steel_notes"
                ></o-textarea>
              </o-widget-wrapper>
              <br />

              <o-widget-wrapper
                :form-state="formState"
                :schema="schema"
                :server-errors="_se"
                :validators="$v.item"
                name="concrete_order"
              >
                <o-date-time
                  :form-state="formState"
                  :server-errors="_se"
                  :validators="$v.item"
                  name="concrete_order"
                  v-bind="schema.fields.concrete_order"
                  v-model="item.concrete_order"
                ></o-date-time>
              </o-widget-wrapper>

              <o-widget-wrapper
                :form-state="formState"
                :schema="schema"
                :server-errors="_se"
                :validators="$v.item"
                name="concrete_notes"
              >
                <o-textarea
                  :form-state="formState"
                  :server-errors="_se"
                  :validators="$v.item"
                  name="concrete_notes"
                  v-bind="schema.fields.concrete_notes"
                  v-model="item.concrete_notes"
                ></o-textarea>
              </o-widget-wrapper>
              <br />

              <o-widget-wrapper
                :schema="schema"
                name="ohs"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-checkbox
                  :form-state="formState"
                  :server-errors="_se"
                  :validators="$v.item"
                  name="ohs"
                  v-bind="schema.fields.ohs"
                  v-model="item.ohs"
                ></o-checkbox>
              </o-widget-wrapper>
              <o-widget-wrapper
                :form-state="formState"
                :schema="schema"
                :server-errors="_se"
                :validators="$v.item"
                name="pod_picked_up_date"
              >
                <o-date-button
                  label="Pod Picked Up"
                  name="pod_picked_up_date"
                  title="Pod Picked Up"
                  v-model="item.pod_picked_up_date"
                  v-bind="schema.fields.pod_picked_up_date"
                  :form-state="formState"
                  :validators="$v.item"
                  :server-errors="_se"
                  hide-time
                ></o-date-button>
              </o-widget-wrapper>
            </div>

            <div v-if="showOtherFields">
              <h3>Pump</h3>
              <o-widget-wrapper
                :schema="schema"
                name="pump"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-select
                  v-model="item.pump"
                  :items="pumpSupplierType"
                  text-field="name"
                  value-field="id"
                  sort-field="name"
                  :form-state="formState"
                  :loading="optionSupplierWorking"
                  name="pump"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.pump"
                  store-name="Supplier"
                >
                </o-select>
              </o-widget-wrapper>

              <o-widget-wrapper
                :schema="schema"
                name="pump_ohs"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-checkbox
                  v-model="item.pump_ohs"
                  :form-state="formState"
                  name="pump_ohs"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.pump_ohs"
                ></o-checkbox>
              </o-widget-wrapper>
            </div>
            <h3>Purchase Order</h3>
            <o-widget-wrapper
              :schema="schema"
              name="purchase_order_number"
              :validators="$v.item"
              :server-errors="_se"
              :form-state="formState"
            >
              <o-text-field
                v-model="item.purchase_order_number"
                :form-state="formState"
                name="purchase_order_number"
                :validators="$v.item"
                :server-errors="_se"
                v-bind="schema.fields.purchase_order_number"
              ></o-text-field>
            </o-widget-wrapper>

            <o-widget-wrapper
              :schema="schema"
              name="date_sent_to_myob"
              :validators="$v.item"
              :server-errors="_se"
              :form-state="formState"
            >
              <o-date-time
                v-model="item.date_sent_to_myob"
                name="date_sent_to_myob"
                v-bind="schema.fields.date_sent_to_myob"
                :form-state="formState"
                :validators="$v.item"
                :server-errors="_se"
              ></o-date-time>
            </o-widget-wrapper>

            <h3>Invoices</h3>
            <o-widget-wrapper
              :schema="schema"
              name="invoices"
              :validators="$v.item"
              :server-errors="_se"
              :form-state="formState"
            >
              <invoice-form-table
                v-model="item.invoices"
                :validators="$v.item.invoices"
                :form-state="formState"
                :label="schema.fields.invoices.label"
                :level="level + 1"
                :server-errors="_se.invoices"
              >
              </invoice-form-table>
              <!-- UNCOMMENT TO USE Cards
                                          <invoice-form-cards v-model="item.invoices"
                                              :validators="$v.item.invoices"
                                              :form-state="formState"
                                              :label="schema.fields.invoices.label"
                                              :level="level+1"
                                              :server-errors="_se.invoices">
                                          </invoice-form-cards>
                                          -->
            </o-widget-wrapper>
            <br />

            <h3>Files</h3>

            <o-widget-wrapper
              :form-state="formState"
              :schema="schema"
              :server-errors="_se"
              :validators="$v.item"
              name="files"
            >
              <file-upload-form-table
                :form-state="formState"
                :label="schema.fields.files.label"
                :level="level + 1"
                :server-errors="_se.files"
                :validators="$v.item.files"
                :parent-id="item.id || 0"
                parent-type="job"
                v-model="item.files"
                :read-only="!canUpdate(schema, 'files')"
              >
              </file-upload-form-table>
            </o-widget-wrapper>

            <email-files
              name="email_files"
              parentType="job"
              :parentId="item.id"
              :emails="emails"
              v-if="canUpdate(schema, 'files')"
            ></email-files>
            <br />

            <h3>Comments</h3>
            <o-widget-wrapper
              :schema="schema"
              name="comments"
              :validators="$v.item"
              :server-errors="_se"
              :form-state="formState"
            >
              <o-textarea
                v-model="item.comments"
                nolabel
                rows="4"
                :form-state="formState"
                name="comments"
                :validators="$v.item"
                :server-errors="_se"
                v-bind="schema.fields.comments"
              ></o-textarea>
            </o-widget-wrapper>
            <br />

            <h3>Notes</h3>
            <o-widget-wrapper
              :schema="schema"
              name="notes"
              :validators="$v.item"
              :server-errors="_se"
              :form-state="formState"
            >
              <o-notes-table
                :form-state="formState"
                :label="schema.fields.notes.label"
                :level="level + 1"
                :server-errors="_se.notes"
                :users="optionUserItemsById"
                :users-working="optionUserWorking"
                :validator="$v.item.notes"
                model-name="Note"
                v-model="item.notes"
                when-field="when"
                who-field="who"
              >
              </o-notes-table>
            </o-widget-wrapper>
          </b-tab>
          <b-tab title="Task" :disabled="!item.id">
            <o-widget-wrapper
              :schema="schema"
              name="job_task"
              :validators="$v.item"
              :server-errors="_se"
              :form-state="formState"
            >
              <!--job-task-form-table v-model="item.job_task"
    :validators="$v.item.job_task"
    :form-state="formState"
    :label="schema.fields.job_task.label"
    :level="level+1"
    :server-errors="_se.job_task">
</job-task-form-table-->
              <job-task-form-cards
                v-model="item.job_task"
                :validators="$v.item.job_task"
                :form-state="formState"
                :label="schema.fields.job_task.label"
                :level="level + 1"
                :server-errors="_se.job_task"
              >
              </job-task-form-cards>
            </o-widget-wrapper>
          </b-tab>
          <b-tab title="Services" lazy :disabled="!item.id">
            <h3>Repairs</h3>
            <b-container fluid="xs">
              <b-row>
                <b-col class="text-right pr-0">Repairs</b-col>
                <b-col cols="10">
                  <service-repair-list-of :job-id="item.id" />
                </b-col>
              </b-row>
            </b-container>
            <br />
            <h3>Maintenance Requests</h3>
            <b-container fluid="xs">
              <b-row>
                <b-col class="text-right pr-0">Maintenance Requests</b-col>
                <b-col cols="10">
                  <service-maintenance-list-of :job-id="item.id" />
                </b-col>
              </b-row>
            </b-container>
            <br />
            <h3>Extras</h3>
            <b-container fluid="xs">
              <b-row>
                <b-col class="text-right pr-0">Extras</b-col>
                <b-col cols="10">
                  <service-extras-list-of :job-id="item.id" />
                </b-col>
              </b-row>
            </b-container>
            <br />
            <h3>Recharges</h3>
            <b-container fluid="xs">
              <b-row>
                <b-col class="text-right pr-0">Recharges</b-col>
                <b-col cols="10">
                  <service-recharge-list-of :job-id="item.id" />
                </b-col>
              </b-row>
            </b-container>
          </b-tab>
          <b-tab title="Pick Up Item" lazy :disabled="!item.id">
            <o-widget-wrapper
              :schema="schema"
              name="pickup_items"
              :validators="$v.item"
              :server-errors="_se"
              :form-state="formState"
            >
              <job-pickup-item-form-table
                v-model="item.pickup_items"
                :validators="$v.item.pickup_items"
                :form-state="formState"
                :label="schema.fields.pickup_items.label"
                :level="level + 1"
                :server-errors="_se.pickup_items"
              >
              </job-pickup-item-form-table>
              <!-- UNCOMMENT TO USE Cards
<job-pickup-item-form-cards v-model="item.pickup_items"
    :validators="$v.item.pickup_items"
    :form-state="formState"
    :label="schema.fields.pickup_items.label"
    :level="level+1"
    :server-errors="_se.pickup_items">
</job-pickup-item-form-cards>
-->
            </o-widget-wrapper>
          </b-tab>
          <b-tab title="Forms" :disabled="!item.id" lazy>
            <b-button
              squared
              v-for="ft in form_templates"
              :key="ft.id"
              :to="{
                name: 'form_entry.create',
                query: {
                  form_template_id: ft.id,
                  other_id: item.id,
                  other_name: 'Job',

                  site_conducted: item.job_location__description,
                  customer: item.customer__name,
                  job_no: item.id,
                  site_address: item.site_address,
                  project_site_address: item.site_address,
                  crew: item.crew_supplier__name,
                  builder: item.customer__name,
                  location: item.job_location__description,
                },
              }"
              >{{ ft.name }}</b-button
            >
            <f-list :other-id="item.id" category="Job" table-inline></f-list>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </o-form-wrapper>
</template>

<script>
import { filter, find } from "lodash";

import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../vue-ocom/mixins";
import { default as SupplierTypeMixin } from "../mixins/supplier_type_mixin";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField";
import ONumberField from "../../../vue-ocom/components/forms/fields/ONumberField";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";
import ONotesTable from "../../../vue-ocom/components/table/common/ONotesTable";
import OMoneyField from "../../components/money_field/OMoneyField";

import { default as CodeJobLocationForm } from "../../code_job_location/components/ItemForm";
import { default as CodeJobTypeForm } from "../../code_job_type/components/ItemForm";
import { default as CustomerForm } from "../../customer/components/ItemForm";
import { default as CrewForm } from "../../supplier/components/ItemForm";
import { default as EmployeeForm } from "../../employee/components/ItemForm";
import { default as SupervisorForm } from "../../supervisor/components/ItemForm";
import { default as InvoiceFormTable } from "../../invoice/components/ItemFormTable";
// import { default as InvoiceFormCards } from '../../invoice/components/ItemFormCards';
import { default as FileUploadFormTable } from "../../file_upload/components/ItemFormTable";
import { default as JobPickupItemFormTable } from "../../job_pickup_item/components/ItemFormTable";

// import { default as FileUploadFormCards } from '../../file_upload/components/ItemFormCards';
// import { default as NoteFormTable } from '../../note/components/ItemFormTable';
// import { default as NoteFormCards } from '../../note/components/ItemFormCards';
import { default as SupplierForm } from "../../supplier/components/ItemForm";
import { default as EmailFiles } from "../../components/email_files/EmailFiles";
import ODateButton from "../../../vue-ocom/components/forms/fields/ODateButton";
import { default as JobTaskFormTable } from "../../job_task/components/ItemFormTable";
import { default as JobTaskFormCards } from "../../job_task/components/ItemFormCards";
import { default as ServiceExtrasListOf } from "../../service_extra/components/ListOf.vue";
import { default as ServiceRepairListOf } from "../../service_repair/components/ListOf.vue";
import { default as ServiceRechargeListOf } from "../../service_recharge/components/ListOf.vue";
import { default as ServiceMaintenanceListOf } from "../../service_maintenance/components/ListOf.vue";
import FSelectTemplate from "@/vue-forms247/app/components/FSelectTemplate";
import FList from "@/vue-forms247/app/components/FList";
import OSpeedSelect from "../../../components/OSpeedSelect";
import CrewSupplierMixin from "../../../mixins/CrewSupplierMixin";

export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("Job"),
    CreateCodeTableFetchMixin([
      "CodeJobLocation",
      "CodeJobType",
      "Customer",
      "CodeFileType",
      "User",
      "Supplier",
      "CodeSupplierType",
      "Employee",
      "Supervisor",
      "FormTemplate",
      "CodeComplexity",
    ]),
    CrewSupplierMixin(),
    SupplierTypeMixin,
  ],
  components: {
    JobPickupItemFormTable,
    ServiceMaintenanceListOf,
    ServiceRechargeListOf,
    ServiceRepairListOf,
    ServiceExtrasListOf,
    FSelectTemplate,
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,
    ONumberField,
    ONotesTable,

    CodeJobLocationForm,
    CodeJobTypeForm,
    CustomerForm,
    CrewForm,
    SupplierForm,
    EmployeeForm,
    SupervisorForm,
    InvoiceFormTable,
    //InvoiceFormCards,
    FileUploadFormTable,
    //FileUploadFormCards,
    //NoteFormTable,
    //NoteFormCards,
    EmailFiles,
    ODateButton,
    JobTaskFormTable,
    JobTaskFormCards,
    FList,
    OMoneyField,
    OSpeedSelect,
  },
  props: {
    item: { type: Object, default: () => {} },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
    create: { type: Boolean, default: false },
  },
  data: () => ({
    concrete_supplied_id: 12,
    schemaModel: cleanUpModel(schema.Job, {}),
    emails: [],
    show_all_inspectors_checkbox: false,
  }),
  methods: {
    select_job_type(id) {
      var jobtype = this.optionCodeJobTypeItemsById[id];

      if (jobtype) {
        if (jobtype.code === "site_cut") {
          this.item.site_cut = true;
        }
        if (jobtype.code === "retaining_wall") {
          this.item.site_cut_retaining_walls = true;
        }
      }
    },
    selected_customer(id) {
      this.$set(this.item, "customer", id); // ensure set so the customer_specific_inspectors_list is recalculated

      var customer = this.optionCustomerItemsById[id];

      if (customer) {
        this.item.part_a_required = customer.auto_part_a_required === true;
        if (this.item.part_a_required) {
          this.item.part_a_supplier = customer.part_a_supplier; // set ID
        } else {
          this.item.part_a_supplier = null; // clear so it's not set from last time
        }

        // Has an inspector picked so check it the same as available and use it
        if (this.item.inspector) {
          var found = _.keyBy(this.customer_specific_inspectors_list, "id")[
            this.item.inspector
          ];
          if (found) return;
        }

        // The current selection is NOT in the list or No Selection so pick one
        if (this.customer_specific_inspectors_list.length > 0) {
          // Pick the first
          this.item.inspector = this.customer_specific_inspectors_list[0].id;
        } else {
          // Nothing to pick so make sure previous selection is not used.
          this.item.inspector = null;
        }
      }
    },
    setSupervisorMobile() {
      this.item.mobile_phone_no =
        this.optionSupervisorItemsById[this.item.supervisor].mobile_phone_no;
    },
    compileEmails() {
      this.addAPossibleEmail(
        this.optionCustomerItems,
        this.item.customer,
        "Customer"
      );
      this.addAPossibleEmail(
        this.optionEmployeeItems,
        this.item.crew_leader,
        "Crew Leader"
      );
      this.addAPossibleEmail(
        this.optionSupervisorItems,
        this.item.supervisor,
        "Supervisor"
      );
      this.addAPossibleEmail(
        this.optionSupplierItems,
        this.item.inspector,
        "Inspector"
      );
      this.addAPossibleEmail(
        this.optionCrewItems,
        this.item.crew_supplier,
        "Crew"
      );
      this.addAPossibleEmail(
        this.optionSupplierItems,
        this.item.part_a_supplier,
        "Part A Supplier"
      );
      this.addAPossibleEmail(
        this.optionSupplierItems,
        this.item.bob_cat,
        "Bobcat Person"
      );
      this.addAPossibleEmail(
        this.optionSupplierItems,
        this.item.pump,
        "Pump Person"
      );
    },

    addAPossibleEmail(optionsList, id, label) {
      if (id) {
        var foundItem = find(optionsList, { id: id });

        if (foundItem) {
          var allowed = true;

          // Allowed if there is an Email and it's not already in the list.
          if (!foundItem.email) {
            allowed = false;
          } else {
            allowed = !_.some(this.emails, { email: foundItem.email });
          }

          if (allowed) {
            this.emails.push({
              label: label,
              email: foundItem.email,
            });
          }
        }
      }
    },
  },
  computed: {
    getSupplierConcreteOnly() {
      let concrete = this.optionSupplierItems.filter((item) => {
        return item.supplier_types.includes(this.concrete_supplied_id);
      });
      return concrete;
    },
    getJobType() {
      if (this.item) return this.item.job_type;

      return 0; // nothing but doesn't error
    },
    showSiteCut() {
      return this.item.site_cut || this.getJobType === 5; // Site_cut item
    },
    showRetainingWalls() {
      return this.item.site_cut_retaining_walls || this.getJobType === 13; // Retaining Walls
    },
    showOtherFields() {
      return !this.showRetainingWalls && !this.showSiteCut;
    },
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
    form_templates() {
      return _.filter(this.optionFormTemplateItems, {
        category: "Job",
        active_end_date: null,
      });
    },
    customer_specific_inspectors_list() {
      var customer = this.optionCustomerItemsById[this.item.customer];
      var suppliers = [];
      var vm = this;

      if (customer) {
        customer.inspectors.forEach(function (inspector_id) {
          suppliers.push(vm.optionSupplierItemsById[inspector_id]);
        });
      }

      return suppliers;
    },
    inspectors_list() {
      if (this.show_all_inspectors_checkbox) {
        return this.supplier("steel");
      } else {
        var customer_supplier_list = this.customer_specific_inspectors_list;

        if (this.item.inspector) {
          var inspectorExists = find(customer_supplier_list, {
            id: this.item.inspector,
          });

          if (!inspectorExists) {
            // "Selected" inspector not in the "customer Specific" list so look for all in all List
            var allSuppliers = this.supplier("steel");

            var existingSupplier = find(allSuppliers, {
              id: this.item.inspector,
            });
            if (existingSupplier) {
              var newSupplierEntry = { ...existingSupplier };
              newSupplierEntry.name =
                newSupplierEntry.name + " (non preferred)";
              customer_supplier_list.push(newSupplierEntry);
            }
          }
        }

        return customer_supplier_list;
      }
    },
    optionCrewSupplierItems() {
      const vm = this;
      let results = vm.optionSupplierItems.filter((item) => {
        if (item.supplier_types) {
          return (
            item.supplier_types.includes(14) || item.supplier_types.includes(2)
          );
        }
        return false;
      });
      return results;
    },
    onlyCrewSupplierItems() {
      const vm = this;
      let results = vm.optionSupplierItems.filter((item) => {
        if (item.supplier_types) {
          return item.supplier_types.includes(14);
        }
        return false;
      });
      return results;
    },
  },
  watch: {
    item: function () {
      this.compileEmails();
    },
  },
  created() {},
};
</script>

<style>
.o-form-page h3 {
  background-color: #eff4fa;
  padding-left: 5px;
  padding-right: 5px;
  border-radius: 5px;
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>
